import { render, staticRenderFns } from "./VocalPlayer.vue?vue&type=template&id=27e6eb14&scoped=true&"
import script from "./VocalPlayer.vue?vue&type=script&lang=js&"
export * from "./VocalPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VocalPlayer.vue?vue&type=style&index=0&id=27e6eb14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e6eb14",
  null
  
)

export default component.exports